import React, { useState, useEffect } from "react";
import { Divider, Skeleton, Space, Row, Col, Alert, Button } from "antd";
import { gql, useLazyQuery } from "@apollo/client";
import moment from "moment-jalaali";
import { PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

const GETPURCHASE = gql`
  query ($id: ID!) {
    getPurchase(id: $id) {
      createdAt
      updatedAt
      description
      reserve {
        startAt
        endAt
        product {
          name
        }
      }
      amount
      user {
        mobile
        name
      }
      product {
        name
        category
      }
      contract  
    }
  }
`;


function PurchasesTableDetails({ id, onDataUpdate, onCloseDrawer }) {
  const [initialData, setInitialData] = useState({});

  const [getPurchaseData, purchaseData] = useLazyQuery(GETPURCHASE, {
    fetchPolicy: "no-cache",
    onCompleted({ getPurchase }) {
      const {
        createdAt,
        updatedAt,
        purchaseType,
        description,
        amount,
        user,
        product,
        reserve,
        contract
      } = getPurchase;
      setInitialData({
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
        purchaseType,
        description,
        amount,
        user,
        product,
        reserve,
        contract
      });
    },
  });
  useEffect(() => {
    if (id) {
      getPurchaseData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const { createdAt, updatedAt, description, amount, user, reserve, product, contract } =
    initialData;
  // const reactToPrintFn = useReactToPrint({
  //   contentRef,
  //   pageStyle: `
  //     @font-face {
  //       font-family: "IRANSansXFaNum";
  //       src: url("${window.location.origin}/fonts/woff2/IRANSansXFaNum-Regular.woff2") format("woff2");
  //     }`,
  // });
  if (purchaseData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  return (
    <>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ ثبت: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>آخرین بروزرسانی: </p>
            {updatedAt}
          </Space>
        </Col>

        <Col sm={12} xs={24}>
          <Space align="">
            <p>دسته بندی خرید: </p>
            {product?.category === "WORK_SPACE"
              ? "فضای کار"
              : product?.category === "CLASS"
                ? "دوره‌های آموزشی"
                : product?.category === "EVENT"
                  ? "رویداد"
                  : product?.category === "CONSULTATION"
                    ? "مشاوره"
                    : product?.category === "MEETING_ROOM"
                      ? "اتاق جلسات"
                      : "-"}
          </Space>
        </Col>
        {product?.name && product?.category === "MEETING_ROOM" ? (
          <Col sm={12} xs={24}>
            <Space>
              <p>مکان برگذاری: {product?.name}</p>
            </Space>
          </Col>
        ) : (
          <Col sm={12} xs={24}>
            <Space>
              <p> سرویس مربوط: {product?.name}</p>
            </Space>
          </Col>
        )}
        <Col span={24}>
          <Space align="">
            <p>توضیحات: </p>
            {description}
          </Space>
        </Col>
      </Row>

      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>کاربر پرداخت کننده:</p>
            {(user && user?.name) || user?.mobile}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>مبلغ: </p>
            {amount?.toLocaleString()} ریال
          </Space>
        </Col>
   
      </Row>
      {reserve && (
        <Row>
          <Alert
            message="قرار ملاقات تنظیم شده"
            description={`قرار ملاقات در تاریخ ${moment(reserve.startAt).format(
              "jYYYY/jMM/jDD"
            )} از ساعت ${moment(reserve.startAt).format("HH:mm")} تا ${moment(
              reserve.endAt
            ).format("HH:mm")} در مکان ${reserve?.product?.name
              } تنظیم شده است.`}
            type="success"
            banner
            style={{ width: "100%", marginBottom: "30px" }}
          />
        </Row>
      )}
      <Divider />
    </>
  );
}

export default PurchasesTableDetails;
